export const Divider = () => {
  return <div className="mx-1 2xl:mx-2 w-0.5 bg-neutral-200 h-6"></div>
}
